import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DocumentsService, UserService } from '../../../../services/common';
import { DocumentSubType } from '../../../../../appconfig';

@Component({
  selector: 'app-booking-documents',
  templateUrl: './booking-documents.component.html',
  styleUrl: './booking-documents.component.scss'
})
export class BookingDocumentsComponent implements OnInit , OnChanges {
  @Input() currentBooking: any
  @Output() bookingDocument = new EventEmitter<any>
  @Input() context: any;
  showKycPanel: boolean = true;
  showCommunicationPanel: boolean = false;
  showEditprofilePanel: boolean = false;
  showReceiptPanel: boolean = false;
  //This will be combined object of user profile and user documents
  userData: any
  userProfileData: any
  userDocumentsData: any
  kycData: any;
  usereditData: any;
  paymentData: any;

  constructor(private userService: UserService, private documentService: DocumentsService) { }

  ngOnInit(): void {
    //get the data of customer of currently selected Booking
    //this.getCurrentSelectedBookingCustomer()
  }

  ngOnChanges(changes: SimpleChanges):void{
    if((changes as any).currentBooking){
      this.getCurrentSelectedBookingCustomer()
    }
  }
  /**
   * This method will subscribed to currently selected booking, by user on booking list
   * whose documents he wants to see
   */
  getCurrentSelectedBookingCustomer() {
    if (this.currentBooking) {
      //Get customer details of current booking
      this.userService.getFilterUser(null, null, null, this.currentBooking?.clientDetail?.id).subscribe((res: any) => {
        if (res) {
          this.userProfileData = res?.result[0];
          this.usereditData = res?.result[0];
          //if User profile data is available then we can find the list of total documents available of this user
          this.documentService.getFilterDocument(this.userProfileData?.id).subscribe(userDocs => {
            var profilePicData: any = null;
            if (userDocs?.result?.length > 0) {
              //set list of all documents of users so that it can be used on KYC Panel too
              this.userDocumentsData = userDocs?.result
              //Check if user has pic data already uploaded or not.
              profilePicData = userDocs?.result?.find((x: any) => x.documentSubTypeId == DocumentSubType.Photo)
              //Sets the user data object
              this.userData = {
                "userId": this.usereditData?.id,
                "userProfileData": this.userProfileData,
                "profilePicfile": profilePicData, // profile pic data is sent for user-profile-pic component
                "documentData" : this.userDocumentsData //documentData is sent for kyc-panel and and land-panel
              }
            }
          });
        }
      });
    }
  }

  /**
   * This will chage the panel in right frame of document screen. Based on user action
   * @param data will decide which panel to show or hide
   */
  changeRightPanel(data: any) {
    this.showKycPanel = !data?.showCommunicationPanel;
    this.showCommunicationPanel = data?.showCommunicationPanel;
  }

  currentContext!: string;
  openEdituserPanel(data: any) {
    this.showKycPanel = !data?.showEditprofilePanel;
    this.showEditprofilePanel = data?.showEditprofilePanel;
    this.currentContext = data.context;
    this.usereditData = data?.customerData;
  }

  changeRightPaymentPanel(data: any) {
    this.showKycPanel = !data?.showReceipt;
    this.showReceiptPanel = data?.showReceipt
  }

  /**
   * Click Tab Land & KYC
   */
  Landclick() {
    this.showKycPanel = false
    // this.bgColor = '#BA141A';
  }

  KYCClick() {
    this.showKycPanel = true
  }
}

